import { render, staticRenderFns } from "./demo-list-tree.vue?vue&type=template&id=c1f2b2ca&scoped=true&"
import script from "./demo-list-tree.vue?vue&type=script&lang=js&"
export * from "./demo-list-tree.vue?vue&type=script&lang=js&"
import style0 from "./demo-list-tree.vue?vue&type=style&index=0&id=c1f2b2ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f2b2ca",
  null
  
)

export default component.exports